import { useCallback, useState } from 'react'

import { toast } from 'sonner'

import { downloadMyDataPdf } from '../services/my-data-export'
import type { MyData } from '../types'

/**
 * Exportação simplificada gerada no front: PDF via @react-pdf/renderer (mesmo
 * mecanismo do PDF de respostas). Trabalha sobre o inventário já carregado na
 * tela "Meus Dados".
 */
export function useDataExport(data: MyData | null) {
  const [isExporting, setIsExporting] = useState(false)

  const requestExport = useCallback(async () => {
    if (!data || isExporting) return
    setIsExporting(true)
    try {
      await downloadMyDataPdf(data)
    } catch {
      toast.error('Não foi possível gerar a exportação. Tente novamente.')
    } finally {
      setIsExporting(false)
    }
  }, [data, isExporting])

  return { requestExport, isExporting }
}
